import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=53a18426&scoped=true"
import script from "./NovoUsuario.vue?vue&type=script&lang=js"
export * from "./NovoUsuario.vue?vue&type=script&lang=js"
import style0 from "./NovoUsuario.vue?vue&type=style&index=0&id=53a18426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a18426",
  null
  
)

export default component.exports